import lodashGet from "lodash.get";
import { patchAccount } from "../../services/api";

export const linkNewAccount = async (
  canvasAccount,
  sfmcDetails,
  accessToken,
  region
) => {
  if (lodashGet(canvasAccount, "integrations.sfmc")) {
    throw new Error("The account already has a sfmc integrations object");
  }
  const sfmcObject = {
    ...sfmcDetails,
  };
  let patchPath;
  let patchValue;
  if (canvasAccount.integrations) {
    patchPath = "/integrations/sfmc";
    patchValue = sfmcObject;
  } else {
    patchPath = "/integrations";
    patchValue = {
      sfmc: sfmcObject,
    };
  }

  const patchOperations = [{ path: patchPath, value: patchValue, op: "add" }];
  await patchAccount(patchOperations, accessToken, region);
};

export const updateLinkedAccount = async (
  canvasAccount,
  sfmcDetails,
  accessToken,
  region
) => {
  if (!lodashGet(canvasAccount, "integrations.sfmc")) {
    throw new Error("The account does not have an sfmc integrations object");
  }

  if (
    lodashGet(canvasAccount, "integrations.sfmc.organizationId") !==
    sfmcDetails.organizationId
  ) {
    throw new Error(
      "The new sfmc account does not match the existing organization id"
    );
  }

  if (
    lodashGet(canvasAccount, "integrations.sfmc.enterpriseId") !==
    sfmcDetails.enterpriseId
  ) {
    throw new Error(
      "The new sfmc account does not match the existing organization id"
    );
  }

  const patchOperations = [];
  patchOperations.push({
    path: "/integrations/sfmc/userId",
    value: sfmcDetails.userId,
    op: "replace",
  });
  patchOperations.push({
    path: "/integrations/sfmc/userEmail",
    value: sfmcDetails.userEmail,
    op: "replace",
  });
  patchOperations.push({
    path: "/integrations/sfmc/refreshToken",
    value: sfmcDetails.refreshToken,
    op: "replace",
  });
  patchOperations.push({
    path: "/integrations/sfmc/activeToken",
    value: sfmcDetails.activeToken,
    op: "replace",
  });
  patchOperations.push({
    path: "/integrations/sfmc/activeTokenExpiry",
    value: sfmcDetails.activeTokenExpiry,
    op: "replace",
  });

  await patchAccount(patchOperations, accessToken, region);
};

export const isSameSfmcAccount = (canvasAccount, sfmcDetails) => {
  return (
    canvasAccount &&
    lodashGet(canvasAccount, "integrations.sfmc.enterpriseId") &&
    canvasAccount.integrations.sfmc.enterpriseId === sfmcDetails.enterpriseId &&
    lodashGet(canvasAccount, "integrations.sfmc.organizationId") &&
    canvasAccount.integrations.sfmc.organizationId ===
      sfmcDetails.organizationId
  );
};

export const isSameSfmcUser = (canvasAccount, sfmcDetails) => {
  return (
    canvasAccount &&
    lodashGet(canvasAccount, "integrations.sfmc.userId") &&
    // (We want the == here as sfmc has userId as a number, we have it as a string)
    // eslint-disable-next-line eqeqeq
    canvasAccount.integrations.sfmc.userId == sfmcDetails.userId &&
    lodashGet(canvasAccount, "integrations.sfmc.userEmail") &&
    canvasAccount.integrations.sfmc.userEmail === sfmcDetails.userEmail
  );
};
